import { render } from "./SideNavDrawerBase.vue?vue&type=template&id=631dc8b9"
import script from "./SideNavDrawerBase.vue?vue&type=script&lang=js"
export * from "./SideNavDrawerBase.vue?vue&type=script&lang=js"

import "./SideNavDrawerBase.vue?vue&type=style&index=0&id=631dc8b9&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__